<template>
  <div class="relative w-full h-full" ref="mainEl">
    <div :style="{ width: `${vWidth}%` }" class="relative h-full center-horizontal">
      <div class="relative w-fit h-full flex flex-col justify-center items-center gap-[0.6rem] center-horizontal">
        <!-- video container -->
        <div class="relative w-fit h-full max-h-[50dvh] flex justify-center items-center" @click="togglePlay()">
          <!-- poster and play btn -->
          <img alt="" class="relative w-full h-full object-contain center top-0 bottom-0 pointer-events-none will-change-transform z-[2]" :src="`/videos/${poster}`" ref="posterEl" />
          <img alt="" class="absolute pointer-events-none will-change-transform z-[3] w-[5rem]" src="images/btn-play-big.png" ref="playBtnEl" v-if="playing == false" />
          <video ref="videoEl" class="absolute top-0 z-[1]" @ended="reset()" preload="none">
            <source type="video/mp4" />
            Your browser does not support HTML video.
          </video>
        </div>
        <!-- scrub -->
        <div class="relative w-full h-fit video-bar py-[0.3rem]" ref="scrubEl">
          <div class="relative bg-[#cbd6e9] rounded-[15px] p-[0.3rem]">
            <div class="relative w-full h-[0.3rem] rounded-[0.3rem] overflow-hidden" ref="barParentEl">
              <div class="relative bg-[#c2ad6c] w-full h-full" ref="yellowBarEl" :style="{ left: `-100%` }"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import gsap from "gsap";

export default {
  name: "video-comp",
  props: {
    url: 0,
    poster: "",
    vWidth: { default: 90 },
    disableBGM: { default: true },
  },

  data() {
    return {
      playing: false,
      duration: 0,
      remainingDur: 0,
      barLength: 0,
      barOffsetLeft: 0,
      barOffsetRight: 0,
      drag: false,
      tween: null,
    };
  },
  methods: {
    handleTouchStart(e) {
      this.drag = true;
      this.getPosition(e);
    },
    handleTouchMove(e) {
      if (this.drag == true) {
        this.getPosition(e);
      }
    },
    handleTouchEnd(e) {
      this.drag = false;
      if (this.playing == true) {
        this.playVideo();
      }
    },
    getPosition(e) {
      this.killRunning();

      var progress;
      var touchX = e.touches ? e.touches[0].clientX : e.clientX;
      var barX;

      if (touchX > this.barOffsetRight) {
        barX = this.barLength;
        progress = 1;
      } else if (touchX < this.barOffsetLeft) {
        barX = 0;
        progress = 0;
      } else {
        barX = touchX - this.barOffsetLeft;
        progress = barX / this.barLength;
      }

      this.$refs.videoEl.pause();
      this.$refs.videoEl.currentTime = progress * this.duration;
      gsap.set(this.$refs.yellowBarEl, { x: barX, overwrite: true });
    },
    animateBar() {
      this.remainingDur = this.duration - this.$refs.videoEl.currentTime;
      this.tween = gsap.to(this.$refs.yellowBarEl, { x: this.barLength, duration: this.remainingDur, ease: "none", overwrite: true });
    },
    togglePlay() {
      if (this.playing == false) {
        this.playVideo();
      } else {
        this.pauseVideo();
      }
    },
    playVideo() {
      console.log("play video");
      gsap.set(this.$refs.posterEl, { autoAlpha: 0 });
      this.playing = true;
      this.$refs.videoEl.play().catch((e) => console.log(e));
      this.animateBar();
    },
    pauseVideo() {
      this.playing = false;
      this.$refs.videoEl.pause();
      this.killRunning();
    },
    jumpTo(dur) {
      this.$refs.videoEl.currentTime = dur;
      gsap.set(this.$refs.yellowBarEl, { x: (dur / this.duration) * this.barLength, overwrite: true });
      this.playVideo();
    },
    killRunning() {
      if (this.tween) {
        this.tween.kill();
      }
    },
    start() {
      const bar = this.$refs.barParentEl.getBoundingClientRect();
      const page = this.$refs.mainEl.getBoundingClientRect();

      console.log("bar", bar);
      console.log("page", page);
      this.barLength = bar.width;
      this.barOffsetLeft = bar.left - page.left;
      this.barOffsetRight = bar.right - page.left;
    },
    reset() {
      this.pauseVideo();
      this.resetValues();
    },
    resetValues() {
      this.$refs.videoEl.currentTime = 0;
      this.remainingDur = this.duration;
      gsap.set(this.$refs.yellowBarEl, { x: 0, overwrite: true });
      gsap.set(this.$refs.posterEl, { autoAlpha: 1 });
    },
    initVideo(url) {
      const video = this.$refs.videoEl;
      video.src = `/videos/${url}`;
      video.load();
      // prettier-ignore
      video.addEventListener("canplaythrough", () => {
      	this.duration = video.duration;
      	this.resetValues();
        this.$emit('loaded');
      }, { once: true });
    },
  },
  mounted() {
    this.$refs.scrubEl.addEventListener("touchstart", this.handleTouchStart);
    this.$refs.scrubEl.addEventListener("touchmove", this.handleTouchMove);
    this.$refs.scrubEl.addEventListener("touchend", this.handleTouchEnd);
    this.$refs.scrubEl.addEventListener("mousedown", this.handleTouchStart);
    this.$refs.scrubEl.addEventListener("mousemove", this.handleTouchMove);
    this.$refs.scrubEl.addEventListener("mouseup", this.handleTouchEnd);
    this.initVideo(this.url);
  },
};
</script>

<style scoped>
video {
  width: 100%;
  height: 100%;
}
</style>
